$(document).ready(function() {
'use strict';

$('.order--container').on('click', function () {
  if ($(this).hasClass('follow__link') == false) {
    var orderId = $(this).attr('order-id');
    $('.order__details[order-id="' + orderId + '"]').slideToggle(200).toggleClass('is-active');
    $(this).toggleClass('child-active');
    $(this).children('.open__line__items--link').children().toggleClass('rotate-180');
  }
});

$(document).ready(function () {
  var params = new URLSearchParams(window.location.search);
  var returnTo = params.get('return_to');

  if (returnTo) {
    var $form = $('#customer_login');

    var $input = $form.find('input[name="return_to"]');

    if ($input.length === 0) {
      $input = $('<input>', {
        type: 'hidden',
        name: 'return_to'
      }).appendTo($form);
    }

    $input.val(returnTo);
  }
});
'use strict';

if (window.collection) {
  var selectedInput = $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').first().text();

  $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').addClass('bg-primary text-white');

  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.select__custom--selected-value').text(selectedInput);
  }
}

$('.sort-by--container').on('click', function () {
  $('.filter-group-summary.checked').children('.plus__icon, .icon--arrow-bottom').removeClass('opened');
  $('.filter-group-summary').removeClass('checked');
  $('.filter-group-display.opened').slideToggle(200).removeClass('opened');
});

/*if (window.matchMedia("(max-width: 767px)").matches) {
  if ($(document).scrollTop() > 550) {
    $('.filter-collection--container').addClass('is-sticky')
  }
  else{
    $('.filter-collection--container').removeClass('is-sticky')
  }

  $(document).on('scroll', function() {
    if ( $(document).scrollTop() > 550 ) {
      $('.filter-collection--container').addClass('is-sticky')
    }
    else{
      $('.filter-collection--container').removeClass('is-sticky')
    }
  });
}*/

$(document).on('click', '.see-more--collection', function (e) {
  e.preventDefault();

  var $button = $(this);
  var nextUrl = $button.attr('url');

  var $text = $button.next('.products-saw--collection');

  if (!nextUrl) return;

  $button.text(window.translate.loading).prop('disabled', true);

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function success(response) {
      var $html = $(response);

      var $newProducts = $html.find('.product-list--collection .product-list--product');

      if ($newProducts.length) {

        var $newButton = $html.find('.see-more--collection');
        var $newCount = $html.find('.products-saw--collection');

        var pageNumber = 1;

        if (nextUrl) {
          var urlObj = new URL(nextUrl, window.location.origin);
          pageNumber = urlObj.searchParams.get('page') || 1;
        }

        $newProducts.each(function () {
          var $product = $(this);

          if ($product.hasClass('push-edito')) {
            var classList = $product.attr('class').split(' ');

            classList.forEach(function (cls) {
              var match = cls.match(/^push-edito-(\d+)-(\d+)$/);

              if (match) {
                var newClass = 'push-edito-' + pageNumber + '-' + match[2];
                $product.removeClass(cls);
                $product.addClass(newClass);
              }
            });
          }
        });

        $('.product-list--collection').append($newProducts);

        if ($newButton.length) {
          $button.attr('url', $newButton.attr('url'));
          $button.text(window.translate.see_more).prop('disabled', false);
        } else {
          $button.remove();
          $text.removeClass('my-[10px]');
          $text.addClass('my-[40px]');
        }

        $text.html($newCount.html());
      } else {
        $button.remove();
      }
    },
    error: function error() {
      $button.text('Erreur, réessayer').prop('disabled', false);
    }
  });
});
'use strict';

if (window.location.href.indexOf("collections/") > -1 && window.general.collection) {
  var updateFilterCount = function updateFilterCount() {
    $('.filter-group').each(function () {
      var totalChecked = 0;
      var checkedCount = $(this).find('.filter--container.checked').length;
      totalChecked += checkedCount;
      var filterGroupCount = $(this).find('.filter-group-count');
      if (totalChecked > 0) {
        filterGroupCount.text('(' + totalChecked + ')');
        filterGroupCount.removeClass('hidden');
      } else {
        filterGroupCount.addClass('hidden');
      }
    });
  };

  var printUrl = function printUrl(list) {
    var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + "?";
    for (var filter in list) {
      filteredUrl += list[filter].type + "=" + list[filter].value + "&";
    }

    var sortBy = $('#sort__by--container .select__custom--value.is__active').attr('value');
    var filterSortBy = 'sort_by=' + sortBy;

    var pageUrl = '';
    /*if (window.location.href.indexOf('page=') > -1){
      var url_string = window.location.href
      var url = new URL(url_string);
      var numberPage = url.searchParams.get("page");
      pageUrl = "&page=" + numberPage
    }*/

    var finalUrl = filteredUrl + filterSortBy + pageUrl;

    if (history.replaceState) {
      window.history.replaceState({ path: finalUrl }, '', finalUrl);
    }

    $.ajax({
      type: 'GET',
      url: finalUrl + '&view=filtered',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));

        clearFilter();

        var countfilter = 0;
        $('.filter--container').each(function () {
          if ($(this).hasClass('checked')) {
            countfilter = countfilter + 1;
          }
        });

        if (countfilter == 0) {
          $('.filterCount').hide().text('');
        } else {
          $('.filterCount').show().text('( ' + countfilter + ' )');
        }

        updateFilterCount();
      },
      error: function error(_error2) {
        console.error(_error2);
      }
    });
  };

  var printActive = function printActive() {
    var countActive = 0;
    $('.active-filters').html('');
    $(".filter-group-display__list-item").each(function () {
      var checkbox = $(this).find('.checkbox-filter--container');
      if (checkbox.hasClass('checked') && checkbox.attr('name') != 'filter.v.availability') {
        countActive += 1;
        var name = $(this).find('.checkbox-filter--container').attr('filtername');
        var value = $(this).find('.checkbox-filter--container').attr('value');
        $('.active-filters').removeClass('hidden').append('\n        <a class="active-filters__remove-filter cursor-pointer flex flex-row items-center bg-secondary-light px-[15px] py-[5px] w-fit" filtername="' + name + '">\n            <p class="subtitle--text text-primary uppercase mx-[5px] ml-0">' + value + '</p>\n            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">\n            <line x1="0.673866" y1="1.00192" x2="5.96387" y2="6.29192" stroke="#80564d"/>\n            <line y1="-0.5" x2="7.48119" y2="-0.5" transform="matrix(-0.707107 0.707107 0.707107 0.707107 6.20312 1.35547)" stroke="#80564d"/>\n            </svg>\n        </a>\n      ');
      }
    });

    if (countActive === 0) {
      $('.active-filters').addClass('hidden');
    }
  };

  $('body').on('click', '.filter-group-summary', function () {

    if ($(this).hasClass('checked')) {
      $(this).removeClass('checked');
      $(this).siblings('.filter-group-display').slideToggle(200);
      $(this).children('.icon--arrow-bottom').removeClass('opened');
    } else {
      $(this).addClass('checked');
      $(this).siblings('.filter-group-display').slideToggle(200);
      $(this).children('.icon--arrow-bottom').addClass('opened');
    }
  });

  // Filters
  $('body').on('click', '.reinitialize__filters', function () {
    window.collection.currentFilters = [];
    $('.reinitialize__filters').hide();
    $('.filter__button').removeClass('is__active');
    var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
    if (history.replaceState) {
      window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
    }
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));

        $('.filterCount').hide().text('');
        updateFilterCount();
      },
      error: function error(_error) {
        console.error(_error);
      }
    });
  });

  var collectionFilter = {};
  if ($('[collection-filter]').html()) {
    collectionFilter = JSON.parse($('[collection-filter]').html());
  }

  //Range slider price
  var $range = $(".js-range-slider"),
      $from = $(".from"),
      $to = $(".to"),
      range,
      min = $range.data('min'),
      max = $range.data('max'),
      from,
      to;

  var updateValues = function updateValues() {
    $from.prop("value", from);
    $to.prop("value", to);

    dataFilter = boucleFilter();
    printUrl(dataFilter);
  };

  var updateFilter = function updateFilter() {
    var maxRange = collectionFilter.filterMaxRange / 100;
    if (from == '0' && to == maxRange) {
      $('.active-filters__remove-filter[filtername="filter-price"]').hide();
    } else {
      $('.active-filters__remove-filter[filtername="filter-price"]').show();
      $('.min-value-filter').text(from + "€");
      $('.max-value-filter').text(to + "€");
    }
  };

  $range.ionRangeSlider({
    onChange: function onChange(data) {
      from = data.from;
      to = data.to;
      updateValues();
      updateFilter();
      $('.irs-from, .irs-to').append(' €');
    }
  });

  $(window).bind("load", function () {
    $('.irs-from, .irs-to').append(' €');
  });

  range = $range.data("ionRangeSlider");
  var updateRange = function updateRange() {
    range.update({
      from: from,
      to: to
    });
  };

  $from.on("input", function () {
    from = +$(this).prop("value");
    if (from < min) {
      from = min;
    }
    if (from > to) {
      from = to;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $to.on("input", function () {
    to = +$(this).prop("value");
    if (to > max) {
      to = max;
    }
    if (to < from) {
      to = from;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $(document).ready(function () {
    if (collectionFilter.filterMaxValue != '') {
      to = collectionFilter.filterMaxValue / 100;
    }
    if (collectionFilter.filterMinValue != '') {
      from = collectionFilter.filterMinValue / 100;
    }
    updateRange();
  });

  var clearFilter = function clearFilter() {
    var url = window.location.href;
    var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
    var count = matches ? matches.length : 0;
    if (window.location.search.indexOf('page=') > -1) {
      count = count - 1;
    }
  };

  $(document).ready(function () {
    clearFilter();
    printActive();
    var countfilter = 0;
    $('.filter--container').each(function () {
      if ($(this).hasClass('checked')) {
        countfilter = countfilter + 1;
      }
    });

    if (countfilter == 0) {
      $('.filterCount').hide().text('');
    } else {
      $('.filterCount').show().text('( ' + countfilter + ' )');
    }

    updateFilterCount();
  });

  var dataFilter = [];

  var boucleFilter = function boucleFilter() {
    var array = [];
    $(".filter-group-display__list").each(function () {
      var containerFilter = $(this).children('.filter-group-display__list-item');

      var checkbox = containerFilter.children('.filter--container').children('.checkbox-filter--container');
      var value = "";
      var name = checkbox.attr('name');
      var compteurCheck = 0;
      for (var i = 1; i <= containerFilter.length; i++) {
        var loopCheckbox = containerFilter.children('.filter--container').children('.checkbox-' + i);

        if (loopCheckbox.hasClass('checked')) {

          /*if (name == "filter.v.option.taille") {
            array.push({type: "filter.v.availability", value: 1})
          }*/

          compteurCheck += 1;

          compteurCheck == 1 ? value = loopCheckbox.attr('value') : value = value + ',' + loopCheckbox.attr('value');
        }
      }
      compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
    });

    var nameFilterLow = $('#lowPriceFilter').attr('name');
    var valueLow = $('#lowPriceFilter').val();

    var nameFilterHigh = $('#highPriceFilter').attr('name');
    var valueHigh = $('#highPriceFilter').val();
    var maxValueHigh = $('#highPriceFilter').attr('max');

    if (parseInt(valueLow) > 0) {
      array.push({ type: nameFilterLow, value: valueLow });
    }

    if (parseInt(valueHigh) <= parseInt(maxValueHigh)) {
      array.push({ type: nameFilterHigh, value: valueHigh });
    }

    /*if (window.matchMedia("(min-width: 951px)" ).matches) {
      if (array.length > 0){
        $('.active-filters__clear').show()
      } else {
        $('.active-filters__clear').hide()
      }
    }*/

    return array;
  };

  if (window.location.href.indexOf("collections") > -1) {
    dataFilter = boucleFilter();
  }

  $('body').on('click', '.active-filters__remove-filter', function () {
    var filter_value = $(this).attr('filtername');
    $('.filter--container[filter-handle="' + filter_value + '"]')[0].click();
  });

  $('body').on('click', '.filter--container', function () {
    var filterTaille = $(this).find('.checkbox-filter--container').attr('name');
    if ($(this).find('.checkbox-filter--container').hasClass('checked')) {
      var filterName = $(this).find('.checkbox-filter--container').attr('filtername');
      $('.active-filters__remove-filter[filtername=' + filterName + ']').remove();
    } else {
      var filterName = $(this).find('.checkbox-filter--container').attr('filtername');

      if (filterName == 'Disponibilité-Enstock') {
        var filterValue = 'En stock';
      } else if (filterTaille == 'filter.v.option.taille') {
        $('.taille--container').removeClass('checked');
        $('.taille--container').children('.checkbox-filter--container').removeClass('checked');
      } else {
        var filterValue = $(this).find('.checkbox-filter--container').attr('value');
      }
    }

    /*if ($('.filter-group-summary').hasClass('checked')){
      $('.filter-group-summary.checked').click()
    }*/

    var checkboxContainer = $(this).children('.checkbox-filter--container');
    checkboxContainer.hasClass('checked') ? checkboxContainer.removeClass('checked') : checkboxContainer.addClass('checked');
    $(this).hasClass('checked') ? $(this).removeClass('checked') : $(this).addClass('checked');

    dataFilter = boucleFilter();

    printUrl(dataFilter);
    printActive();

    if (window.matchMedia("(max-width: 768px)").matches) {
      $("html, body").animate({ scrollTop: 0 }, 1000);
    }
  });

  var countEuro = 1;
  /*$('body').on('click', '.filter-group-summary', function() {
    if ($(this).hasClass('checked')){
      $(this).removeClass('checked')
      $(this).siblings('.filter-group-display').slideToggle(200).removeClass('opened')
      $(this).children('.plus__icon, .icon--arrow-bottom').removeClass('opened')
    } else {
      $('.filter-group-summary.checked').children('.plus__icon, .icon--arrow-bottom').removeClass('opened')
      $('.filter-group-summary').removeClass('checked')
      $('.filter-group-display.opened').slideToggle(200).removeClass('opened')
      $(this).addClass('checked')
      $(this).siblings('.filter-group-display').slideToggle(200).addClass('opened')
      $(this).children('.plus__icon, .icon--arrow-bottom').addClass('opened')
       setTimeout(function(){
        if (countEuro == 1){
          countEuro = countEuro + 1;
          $('.irs-from, .irs-to').append(' €')
        }
      }, 200);
    }
   })*/

  $('body').on('click', '.see-more', function () {
    var which = $(this).attr('which');
    $('.see-more[which="' + which + '"]').hide();
    $('.see-less[which="' + which + '"]').show();

    $('.filter-group-display.' + which + '--container').addClass('opened');
  });

  $('body').on('click', '.see-less', function () {
    var which = $(this).attr('which');
    $('.see-more[which="' + which + '"]').show();
    $('.see-less[which="' + which + '"]').hide();

    $('.filter-group-display.' + which + '--container').removeClass('opened');
  });

  $('body').on('click', '.active-filters__clear', function () {
    var link = $(this).attr('link');
    $('.filter--container, .checkbox-filter--container').removeClass('checked');

    /*$('#lowPriceFilter').attr('value', 0)
    var maxRangeValue = (collectionFilter.filterMaxRange) / 100
    $('#highPriceFilter').attr('value', maxRangeValue)
    $('#highPriceFilter').val(maxRangeValue)
    to = maxRangeValue
    from = 0
    updateValues();
    updateRange();
    $('.irs-from, .irs-to').append(' €')*/
    window.history.replaceState({ path: link }, '', link);

    $('.count-filter--container').addClass('hide');

    $.ajax({
      type: 'GET',
      url: link + '&view=filtered',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container, .collection-remove--container').remove();
        $('#collection__page--desktop').append(content.substring(4));

        clearFilter();
        printActive();
        $('.filterCount').hide().text('');
        updateFilterCount();
      },
      error: function error(_error3) {
        console.error(_error3);
      }
    });
  });
}
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

$('body').on('click', '.add__to__cart', function (e) {
  e.preventDefault();
  var variantId = $(this).attr('variant-id');
  var available = $(this).attr('variant-available');
  var productHandle = $(this).attr('product-handle');
  var variants = $(this).attr('variants');
  var type = $(this).attr('button-type');
  var eta = $(this).attr('eta');
  if (available == 'true' || available == true) {
    if (variantId) {
      var qty = 1;
      if (type == 'product') {
        qty = $('.product__qty--container .quantity__current').val();
      }
      var objUpdate = { quantity: qty, id: variantId };
      if (eta != '') {
        objUpdate = {
          quantity: qty,
          id: variantId,
          properties: _defineProperty({}, window.general.eta, eta)
        };
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: objUpdate,
        dataType: 'json',
        success: function success(response) {
          updateCartData(true);
          renderCart();
          document.dispatchEvent(new CustomEvent('update-reco-drawer'));

          if ($('#empty__cart--title').length > 0) {
            location.reload(true);
          }

          document.dispatchEvent(new CustomEvent('cart:open'));
          $(this).children('.button--text').css('display', 'block');
          $(this).children('.button--loading').css('display', 'none');

          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:update'));
          }, 500);
        },
        error: function error(_error) {
          console.error(_error);
        }
      });
    }
  }
});

$('body').on('click', '.remove--line-item', function (e) {
  e.preventDefault();
  var $this = $(this);
  var key = $(this).attr('key');

  var data = { updates: {} };
  data.updates[key] = 0;
  setTimeout(function () {
    $('.cart__item--container[key="' + key + '"]').remove();
  }, 300);
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function success(response) {
      updateCartData(false);
      renderCart();
      document.dispatchEvent(new CustomEvent('update-reco-drawer'));
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:update'));
      }, 500);
    },
    error: function error(_error2) {
      console.error(_error2);
    }
  });
});

$('body').on('change', '.qty--input', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $this.val();

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        // On render le cart via le module shippinh-module-cart.js
        updateCartData(false);

        document.dispatchEvent(new CustomEvent('cart:update'));
      },
      error: function error(_error3) {
        console.error(_error3);
      }
    });
  }
});

function klaviyoCart(response) {
  var _learnq = window._learnq || [];
  var cart = {
    total_price: response.total_price / 100,
    $value: response.total_price / 100,
    total_discount: response.total_discount,
    original_total_price: response.original_total_price / 100,
    items: response.items
  };
  _learnq.push(['track', 'Added to Cart', cart]);
}

var updateCartData = function updateCartData(add) {
  var url = '/cart';
  if (window.general.langue != 'fr') {
    url = '/' + window.general.langue + '/cart';
  }
  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json',
    success: function success(response) {

      if (add == true) {
        klaviyoCart(response);
      }

      var total = response.total_price;
      var empty = response.item_count == 0 ? true : false;
      //updateDeliveryModule(total);
      if (empty) {
        $('.cart--body').addClass('flex flex-col justify-center items-center');
        $('.total-drawer--container').addClass('hidden');
        $('.empty__cart--drawer').removeClass('hidden');
        $('.items--count').text(0).addClass('hidden');

        if ($('#full__cart--title').length > 0) {
          location.reload(true);
        }
      } else {
        var getCurrencySymbol = function getCurrencySymbol() {
          var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

          var s = String(str).trim();

          var closeIdx = s.indexOf("}}");
          // Cas 1: {{amount}}€  → il y a quelque chose après "}}"
          if (closeIdx !== -1) {
            var right = s.slice(closeIdx + 2).trim();
            if (right) return right; // ex: "€" ou "EUR"
          }

          // Cas 2: ${{amount}} → il y a quelque chose avant "{{"
          var openIdx = s.indexOf("{{");
          if (openIdx !== -1) {
            var left = s.slice(0, openIdx).trim();
            if (left) return left; // ex: "$" ou "USD"
          }

          return "";
        };

        $('.cart--body').removeClass('flex flex-col justify-center items-center');
        $('.total-drawer--container').removeClass('hidden');
        $('.empty__cart--drawer').addClass('hidden');

        var price_display;
        if (window.general.currency.includes('$') || window.general.currency.includes('Afl')) {
          price_display = getCurrencySymbol(window.general.currency) + displayPrice(total);
        } else {
          price_display = displayPrice(total) + getCurrencySymbol(window.general.currency);
        }

        $('.cart__total--drawer').text(price_display);

        $('.items--count').text(response.item_count).removeClass('hidden');
      }
    },
    error: function error(_error4) {
      console.error(_error4);
    }
  });
};

var renderCart = function renderCart() {
  var url = '/cart?view=sidecart&timestamp=' + Date.now();

  if (window.general.langue != 'fr') {
    url = '/' + window.general.langue + '/cart?view=sidecart&timestamp=' + Date.now();
  }

  if (window.location.href.indexOf("/cart") > -1) {
    url = '/cart?view=page&timestamp=' + Date.now();
  }

  $.ajax({
    type: 'GET',
    url: url,
    success: function success(content) {
      var newCart = content;
      $('.cart__items__and__header--container').remove();
      $('.cart--body').append(newCart);

      if (window.location.href.indexOf("/cart") > -1) {
        $('#cart--title, .side-bar-cart').remove();
        $('.form-cart').removeClass('grid-cols-[calc(75%-20px)_calc(25%-20px)] gap-x-[40px]').addClass('grid-cols-1');
      }
    },
    error: function error(_error5) {
      console.error(_error5);
    }
  });
};

document.addEventListener('cart:open', function (elem) {
  $("#cart__drawer").addClass('opened');
  $('#page__overlay').addClass('opened').attr('for', 'drawer');
  setTimeout(function () {
    $('#drawer__cart--exta-infos').addClass('opened');
  }, 350);
}, false);

document.addEventListener('cart:update', function () {
  var eco_price = 0;
  $('.cart__item--container').each(function () {
    var eco_product = $(this).attr('eco');
    var quantity_product = $(this).find('.qty--input').val();

    var eco_product_calc = eco_product * quantity_product;
    eco_price += eco_product_calc;
  });

  // Arrondir eco_price à deux décimales
  eco_price = parseFloat(eco_price).toFixed(2);

  $('.js-eco-particpation').text(eco_price);
});
"use strict";

if (window.cart) {
  var deliveryModuleWidth = 100;
  var renderFirst = 0;

  var nbSteps = window.cart.nbSteps;
  if (nbSteps > 1 && nbSteps < 3) {
    deliveryModuleWidth = 33.33;
  } else if (nbSteps > 2) {
    deliveryModuleWidth = 25;
  }
  var ajaxCartProducts = function ajaxCartProducts(qty1) {
    var objUpdate = { updates: {} };
    objUpdate.updates[44816234283284] = qty1;

    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: objUpdate,
      dataType: "json",
      success: function success(response) {
        renderCart();
      },
      error: function error(_error) {
        console.error(_error);
      }
    });
  };

  var shippingBarLogic = function shippingBarLogic(total) {
    var currentStep = 1;
    if (total >= window.cart.steps[0] && total < window.cart.steps[1]) {
      currentStep = 2;
    } else if (total >= window.cart.steps[1]) {
      currentStep = 3;
    }

    var remainMoney = 0;
    var remainPercentage = 0;
    var colorBar = 0;

    var barCalculus = function barCalculus(step, total) {
      var seuilSuivant = window.cart.steps[step - 1];
      var seuilPrecedent = 0;
      if (step != 1) {
        seuilPrecedent = window.cart.steps[step - 2];
      }

      remainMoney = Math.max(0, (seuilSuivant - total) / 100);
      remainPercentage = Math.max(0, (seuilSuivant - total) / (seuilSuivant - seuilPrecedent));
      colorBar = deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
    };

    var finalStep = function finalStep() {
      remainMoney = 0;
      remainPercentage = 0;
      colorBar = 100;
    };

    switch (currentStep) {
      case 1:
        barCalculus(1, total);
        break;
      case 2:
        barCalculus(2, total);
        break;
      case 3:
        barCalculus(3, total);
        break;
      default:
        break;
    }

    if (currentStep == 1) {
      ajaxCartProducts(0);
    } else if (currentStep == 2 && nbSteps > 1) {
      if (nbSteps == 1) {
        finalStep();
      } else {
        if (window.cart.deliveryStep == 1) {
          ajaxCartProducts(0);
        } else {
          ajaxCartProducts(1);
        }
      }
    } else {
      finalStep();
      if (window.cart.deliveryStep == 0 && nbSteps == 2) {
        ajaxCartProducts(1);
      } else if (window.cart.deliveryStep == 0 && nbSteps == 1) {
        ajaxCartProducts(1);
      } else if ((window.cart.deliveryStep == 1 || window.cart.deliveryStep == 2) && nbSteps == 2) {
        ajaxCartProducts(1);
      } else {
        ajaxCartProducts(0);
      }
    }

    $('#progress__bar--remain').css('width', colorBar + '%');

    if (remainMoney > 0) {
      var moinsDix = remainMoney < 10 ? true : false;
      remainMoney = remainMoney.toString().replace('.', ',');
      if (moinsDix == true && remainMoney.length == 3) {
        remainMoney = remainMoney + '0';
      } else if (moinsDix == false && remainMoney.length == 4) {
        remainMoney = remainMoney + '0';
      }

      $('#free__shipping--message').hide();
      $('#remain__shipping__amount--message').show();
      $('#amount__remaining').text(remainMoney + "€");
    } else {
      $('#free__shipping--message').show();
      $('#remain__shipping__amount--message').hide();
    }
  };

  var getCartTotal = function getCartTotal(callback, cart) {
    if (cart) {
      if (callback) {
        callback(cart.total_price);
      } else {
        return cart.total_price;
      }
    } else {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function success(cart) {
          if (callback) {
            callback(cart.total_price);
          } else {
            return cart.total_price;
          }
        }
      });
    }
  };

  var initializeDeliveryModule = function initializeDeliveryModule() {
    var total = getCartTotal(shippingBarLogic);
  };

  if (window.cart.emptyCart == false) {
    setTimeout(function () {
      initializeDeliveryModule();
    }, 1000);
  }

  var updateDeliveryModule = function updateDeliveryModule(total) {
    if (window.cart.deliveryModule) {
      if (total) {
        shippingBarLogic(total);
      } else {
        getCartTotal(shippingBarLogic);
      }
    }
  };
}
'use strict';

document.addEventListener('update-reco-drawer', function (e) {
  var url = 'https://' + window.location.hostname + '/?section_id=reco-lateral';
  if (window.general.langue != 'fr') {
    url = 'https://' + window.location.hostname + '/' + window.general.langue + '/?section_id=reco-lateral';
  }
  $.ajax({
    type: 'GET',
    url: url,
    success: function success(data) {
      $('#product-reco--container').empty().append(data);
      setTimeout(function () {
        $('.slider-reco-lateral').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          variableWidth: true
        });
      }, 500);
    },
    error: function error(_error) {
      console.error(_error);
    }
  });
}, false);
'use strict';

// Ouvrir la modal au clic
$('body').on('click', '.button__action', function (e) {
  e.preventDefault();
  var buttonFor = $(this).attr('for');
  var selector = $(this).attr('open-selector');

  if (selector) {
    $(selector).addClass('opened');
    if (selector == '#filter-collection-drawer') {
      $('#page__overlay-filter').addClass('opened');
    } else {
      $('#page__overlay').addClass('opened');
    }
  }

  if (buttonFor == 'drawer' && selector) {

    // Disable scroll on body
    document.body.style.overflow = 'hidden';

    if (selector == '#filter-collection-drawer') {
      $('#page__overlay-filter').attr('for', 'drawer');
    } else {
      $('#page__overlay').attr('for', 'drawer');
    }
  } else if (buttonFor == 'drawer-cart' && selector) {
    $('#page__overlay').attr('for', 'drawer');
    setTimeout(function () {
      $('#drawer__cart--exta-infos').addClass('opened');
    }, 350);
  } else if (buttonFor == 'accordeon') {
    var isActive = false;
    if ($(this).hasClass('active')) {
      isActive = true;
    }
    if ($(this).hasClass('link--item-button')) {
      $('.link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.link--item-button.active').removeClass('active');
    } else if ($(this).hasClass('sub__link--item-button')) {
      $('.sub__link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.sub__link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.sub__link--item-button.active').removeClass('active');
    }

    if (isActive == false) {
      $(this).toggleClass('active');
      $(this).children('.plus__icon').toggleClass('opened');
      $(this).siblings('.accordeon__list').addClass('opened').slideToggle('500');
    }
  } else if (buttonFor == 'modal' && selector) {
    $('#page__overlay').attr('for', 'modal');
  }
});

// Fermer la modal au clic sur la croix
$('body').on('click', '.close', function (e) {
  e.preventDefault();
  var closeFor = $(this).attr('for');

  $('#page__overlay, #page__overlay-filter').removeClass('opened');
  $('#page__overlay, #page__overlay-filter').attr('for', '');

  if (closeFor == 'drawer') {
    $('.drawer').removeClass('opened');

    // Enable scroll on body
    document.body.style.overflow = 'auto';
  } else if (closeFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  }
});

// Clic en dehors de la'modal'
$('#page__overlay, #page__overlay-filter').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  $(this).removeClass('opened');
  $('#page__overlay, #page__overlay-filter').attr('for', '');

  if (overlayFor == 'drawer') {
    $('.drawer').removeClass('opened');

    // Enable scroll on body
    document.body.style.overflow = 'auto';
  } else if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  }
});
'use strict';

$('body').on('click', '.select__custom--selected-value-container', function (e) {
  var forSelect = $(this).attr('for');

  $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50).addClass('opened');
  $('.select__custom--values:not([for="' + forSelect + '"])').hide().removeClass('opened');

  $(this).children('.icon--arrow-bottom').toggleClass('opened');
  $('.select__custom--selected-value-container:not([for="' + forSelect + '"])').children('.icon--arrow-bottom').removeClass('opened');
});

$('body').on('click', '.select__custom--value', function (e) {
  var forSelect = $(this).attr('for');
  var value = $(this).attr('value');
  var valueText = $(this).text();

  $('.select__custom--selected-value-container').children('.icon--arrow-bottom').removeClass('opened');
  $('.select__custom--selected-value[name="' + forSelect + '"]').text(value);
  $('.select__hidden[for="' + forSelect + '"]').val(value).trigger('change');
  $('.select__custom--values').hide().removeClass('opened');

  if (forSelect == "sort--by") {
    $('.select__custom--value').removeClass('bg-primary text-white').addClass('text-grey');
    $(this).addClass('bg-primary text-white').removeClass('text-grey');
  } else if (forSelect == "product__option--1") {
    //$('.select__custom--value').removeClass('bg-secondary-light')
    //$(this).addClass('bg-secondary-light')
  }

  document.dispatchEvent(new CustomEvent('select-changed:product__option'));
});

$(document).on('click', function (e) {
  var product = $(".select__custom--values");
  var product2 = $(".click-select");
  if (product.is(e.target) || product2.is(e.target)) {} else {
    if (product.hasClass('opened')) {
      $(product).hide().removeClass('opened');
      $('.select__custom--selected-value-container').children('.icon--arrow-bottom').removeClass('opened');
    }
  }
});

Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('.select__hidden[for="sort--by"]').bind('change', function () {
  Shopify.queryParams.sort_by = $(this).val();
  var filteredUrl = window.location.href;

  var url = new window.URL(window.location.href);
  url.searchParams.set("sort_by", Shopify.queryParams.sort_by);

  filteredUrl = url.toString().replace('%2C', ',');

  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }

  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      var count = parseInt(content.substring(0, 4));
      $('.filter-count').text(count);
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content.substring(4));

      //clearFilter()
    },
    error: function error(_error) {
      console.error(_error);
    }
  });
});
"use strict";

var prevArrow = "<svg class=\"slick-arrow--left absolute top-[45%] translate-y-[-50%] w-[36px] h-[36px] left-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" viewBox=\"0 0 53.4 18.8\"><path style=\"fill:#404040;\" d=\"M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z\"/></svg>";
var nextArrow = "<svg class=\"slick-arrow--right absolute top-[45%] translate-y-[-50%] w-[36px] h-[36px] right-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" x=\"0px\" y=\"0px\"viewBox=\"0 0 53.4 18.8\" style=\"enable-background:new 0 0 53.4 18.8;\" xml:space=\"preserve\"><path style=\"fill:#404040;\" d=\"M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z\"/> </svg>";
var prevArrowMobile = "<svg class=\"slick-arrow--left absolute top-[40%] translate-y-[-50%] w-[36px] h-[36px] left-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" viewBox=\"0 0 53.4 18.8\"><path style=\"fill:#404040;\" d=\"M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z\"/></svg>";
var nextArrowMobile = "<svg class=\"slick-arrow--right absolute top-[40%] translate-y-[-50%] w-[36px] h-[36px] right-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" x=\"0px\" y=\"0px\"viewBox=\"0 0 53.4 18.8\" style=\"enable-background:new 0 0 53.4 18.8;\" xml:space=\"preserve\"><path style=\"fill:#404040;\" d=\"M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z\"/> </svg>";
var prevArrowGallery = "<svg class=\"slick-arrow--left absolute top-[50%] translate-y-[-50%] w-[36px] h-[36px] left-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" viewBox=\"0 0 53.4 18.8\"><path style=\"fill:#404040;\" d=\"M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z\"/></svg>";
var nextArrowGallery = "<svg class=\"slick-arrow--right absolute top-[50%] translate-y-[-50%] w-[36px] h-[36px] right-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" x=\"0px\" y=\"0px\"viewBox=\"0 0 53.4 18.8\" style=\"enable-background:new 0 0 53.4 18.8;\" xml:space=\"preserve\"><path style=\"fill:#404040;\" d=\"M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z\"/> </svg>";

var initSlick = function initSlick() {
    $(".edito-lookbook__slider").slick({
        infinite: false,
        variableWidth: true,
        prevArrow: "\n            <svg width=\"24px\" height=\"24px\" stroke-width=\"1.5\" viewBox=\"0 0 24 24\" fill=\"none\" color=\"currentColor\">\n                <path d=\"M15 6L9 12L15 18\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>\n            </svg>\n        ",
        nextArrow: "\n            <svg width=\"24px\" height=\"24px\" stroke-width=\"1.5\" viewBox=\"0 0 24 24\" fill=\"none\" color=\"currentColor\">\n                <path d=\"M9 6L15 12L9 18\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>\n            </svg>\n        "
    });

    $(".announcement-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        dots: false,
        infinite: true,
        arrows: false
    });

    $("#bandeau--footer-slider").slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1150,
            settings: {
                slidesToShow: 3,
                dots: true,
                customPaging: function customPaging(slider, i) {
                    return '<button class="tab"></button>';
                }
            }
        }, {
            breakpoint: 950,
            settings: {
                slidesToShow: 2,
                dots: true,
                customPaging: function customPaging(slider, i) {
                    return '<button class="tab"></button>';
                }
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                dots: true,
                customPaging: function customPaging(slider, i) {
                    return '<button class="tab"></button>';
                }
            }
        }]
    });

    $(".four-product-slider").slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 950,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 500,
            settings: {
                slidesToShow: 1
            }
        }]
    });

    $(".slider-projet").slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 950,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                variableWidth: true
            }
        }]
    });
    if (window.matchMedia("(min-width: 768px)").matches) {
        $(".slider-produit").each(function () {
            var $slider = $(this);
            var slideCount = $slider.attr("size");

            $slider.slick({
                dots: false,
                infinite: true,
                arrows: true,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1150,
                    settings: {
                        slidesToShow: 3
                    }
                }]
            });
        });
    }

    if (window.matchMedia("(max-width: 768px)").matches) {
        $(".slider-produit-mobile").each(function () {
            var $slider = $(this);
            var slideCount = $slider.attr("size");

            $slider.slick({
                dots: false,
                infinite: true,
                arrows: true,
                prevArrow: prevArrowMobile,
                nextArrow: nextArrowMobile,
                slidesToShow: 2,
                slidesToScroll: 1
            });
        });
    }

    $(".slider-collection").slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1
            }
        }]
    });
    if (window.matchMedia("(max-width: 1200px)").matches) {
        $(".slider-collection-mobile").slick({
            dots: false,
            infinite: true,
            arrows: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }]
        });
    }

    $(".slider-designer").slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [{
            breakpoint: 950,
            settings: {
                centerMode: true
            }
        }]
    });

    if (window.matchMedia("(max-width: 950px)").matches) {
        $(".slider-logo-btob").slick({
            dots: false,
            infinite: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            autoplay: true,
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true
                }
            }]
        });
    }

    $(".slider-diptyque").slick({
        autoplay: true,
        autoplaySpeed: $(".slider-diptyque").attr("data-delai-slider") * 1000,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        customPaging: function customPaging(slider, i) {
            return '<button class="tab"></button>';
        },
        dots: true,
        infinite: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                infinite: false,
                slidesToShow: 1.2
            }
        }],
        slidesToShow: 2,
        slidesToScroll: 1
    });

    $(".slider-reco").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        variableWidth: true
    });

    if (window.matchMedia("(min-width: 768px)").matches) {
        $("#instagram-feed").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            arrows: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            variableWidth: true
        });

        $("#slider-edito").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            arrows: true,
            prevArrow: "\n                <svg class=\"slick-arrow--left absolute top-[50%] translate-y-[-50%] w-[30px] h-[30px] left-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" width=\"16px\" height=\"16px\" stroke-width=\"1.5\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" color=\"#211f1f\"><path d=\"M15 6L9 12L15 18\" stroke=\"#211f1f\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>\n            ",
            nextArrow: "\n                <svg class=\"slick-arrow--right absolute top-[50%] translate-y-[-50%] w-[30px] h-[30px] right-[-18px] z-[2] cursor-pointer bg-white rounded-full p-[6px]\" width=\"16px\" height=\"16px\" stroke-width=\"1.5\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" color=\"#211f1f\"><path d=\"M9 6L15 12L9 18\" stroke=\"#211f1f\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>\n            ",
            variableWidth: true
        });
    }
};

initSlick();

document.addEventListener("theme-editor--slick", function (e) {
    $(".background-slider").filter(".slick-initialized").slick("unslick");
    $(".carousel-product-list").filter(".slick-initialized").slick("unslick");
    $(".blog-slider").filter(".slick-initialized").slick("unslick");
    //$('#instagram-feed').filter('.slick-initialized').slick('unslick');
    $("#bandeau--footer-slider").filter(".slick-initialized").slick("unslick");

    initSlick();
}, false);

$(window).on("load", function () {
    $("#announcement--container .text-slide").css("opacity", "1");
});
'use strict';

if (window.matchMedia("(max-width: 767px)").matches) {
  $('#sidebar-accordion-footer .plus__icon').show();
  $('#sidebar-accordion-footer').find('li.extend').click(function (e) {
    $(this).children('.extended-submenu').slideToggle('fast').css('display', 'flex');
    $(this).children('.nav__footer--title').children('.plus__icon').toggleClass('opened');
    $(this).toggleClass('active');
  });
}

$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').show();
  }
});
'use strict';

var pageOverlayOpened = false;
$(".navigation__item--link-megamenu").mouseenter(function () {
  if (pageOverlayOpened == false) {
    $('#page__overlay--navigation').addClass('opened');
    pageOverlayOpened = true;
  }
});

$(".navigation__item--link-megamenu").mouseleave(function () {
  if (pageOverlayOpened == true) {
    $('#page__overlay--navigation').removeClass('opened');
    pageOverlayOpened = false;
  }
});

// Gestion de la hauteur du drawer sur mobile
// a utiliser si le drawer ne fait pas 100% de l'ecran, sinon on peut commenter
var navbarHeightMobile;
if (window.matchMedia("(max-width: 1200px)").matches) {
  if ($(document).scrollTop() > 20) {
    navbarHeightMobile = 60;
  } else {
    if (window.matchMedia("(max-width: 767px)").matches) {
      navbarHeightMobile = 88;
    } else {
      navbarHeightMobile = 96;
    }
  }
} else {
  if ($(document).scrollTop() > 20) {
    navbarHeightMobile = 159;
  } else {
    navbarHeightMobile = 195;
  }
}

$('#navigation__drawer, #cart__drawer').css('height', window.innerHeight); // init
$('#filter-collection-drawer').css('height', window.innerHeight).css('top', 0);
$(document).on('scroll', function () {
  $('#navigation__drawer, #cart__drawer').css('height', window.innerHeight);
  if (window.matchMedia("(max-width: 1200px)").matches) {
    if ($(document).scrollTop() > 20) {
      navbarHeightMobile = 60;
    } else {
      if (window.matchMedia("(max-width: 767px)").matches) {
        navbarHeightMobile = 88;
      } else {
        navbarHeightMobile = 96;
      }
    }
  } else {
    if ($(document).scrollTop() > 20) {
      navbarHeightMobile = 159;
    } else {
      navbarHeightMobile = 195;
    }
  }
  $('#filter-collection-drawer').css('height', window.innerHeight).css('top', 0);
});

$('.info--container').mouseenter(function () {
  $('.info-hover--container').removeClass('hidden');
  $('#page__overlay--navigation').addClass('opened');
});
$('.info--container').mouseleave(function () {
  $('.info-hover--container').addClass('hidden');
  $('#page__overlay--navigation').removeClass('opened');
});

$('.click-nav-mobile').on('click', function () {
  $('#navigation__drawer .close').click();
  $('#icon-search').click();
});

if ($(document).scrollTop() > 20) {
  $('#navigation--container .top--container').addClass('black-header');
} else {
  $('#navigation--container .top--container').removeClass('black-header');
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $('#navigation--container .top--container').addClass('black-header');
  } else {
    $('#navigation--container .top--container').removeClass('black-header');
  }
});
"use strict";

var pathname = window.location.pathname;
var langCode = pathname.split("/")[1];

var localePrefix = "";
if (/^[a-z]{2}(-[a-z]{2})?$/.test(langCode)) {
  localePrefix = '/' + langCode;
}

if (window.location.href.indexOf("blog") > -1 || window.location.href.indexOf("article") > -1) {
  $('#icon-search-blog, #icon-search-blog-2').on('click', function () {
    if ($('.search--container').hasClass('opened-blog')) {
      $('.search--container').removeClass('opened-blog');
      $('.searchArticle').val('');
      $(".result-search").html('');
    } else {
      $('.search--container').addClass('opened-blog');
    }
  });

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchArticle').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened-blog');
    $('.search--container').css('transform', '');
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {

    var container = $(".search--container");
    var container2 = $(".search--container-barre");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if (container.hasClass('opened-blog') && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }

    if (!container2.is(e.target) && container2.has(e.target).length === 0) {
      $('.searchArticle-barre').val('');
      $('.result-search-barre').html('');
    }
  });
} else {
  var handleSearchBar = function handleSearchBar(searchTriggerId, positionScrolledClass, positionClass, translateYScrolled, translateY) {
    $(searchTriggerId).on('click', function () {
      if ($('.search--container').hasClass(positionScrolledClass) || $('.search--container').hasClass(positionClass)) {
        $('#page__overlay--navigation').removeClass('opened');
        $('.navigation__item--container').removeClass('search--opened');
        $('#navigation--container').removeClass('fixedWhiteNav');
        $('.search--container').removeClass(positionScrolledClass + " " + positionClass).css('transform', '');
        $('.searchProduct').val('');
        $(".result-search").html('');
        $(".popular_product").removeClass('opened');
      } else {
        $('#page__overlay--navigation').addClass('opened');
        $('#navigation--container').addClass('fixedWhiteNav').removeClass('transparent--nav');
        $(".popular_product").addClass('opened');
        if ($(document).scrollTop() >= 20) {
          $('.search--container').addClass(positionScrolledClass);
          $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + translateYScrolled + "px)");
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $('.search--container').addClass(positionClass);
          $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
        }
      }
      $('.searchProduct.search--input').focus();
    });

    $(document).on('scroll', function () {
      if ($(document).scrollTop() >= 20) {
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + translateYScrolled + "px)");
      } else {
        var topPosition = translateY - $(document).scrollTop();
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
      }
    });
  };

  if (window.matchMedia("(max-width: 767px)").matches) {
    handleSearchBar('#icon-search', 'opened-mobile-scroll', 'opened-mobile2', 260, 288);
  } else if (window.matchMedia("(max-width: 1200px)").matches) {
    handleSearchBar('#icon-search', 'opened-mobile-scroll', 'opened-mobile', 260, 296);
  } else {
    handleSearchBar('#icon-search', 'opened-scroll', 'opened', 323, 359);
  }

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchProduct').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2').css('transform', '');
    $('#navigation--container').removeClass('fixedWhiteNav');
    $('#page__overlay--navigation').removeClass('opened');
    $('.navigation__item--container').removeClass('search--opened');
    $('.popular_product').removeClass('opened');
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {
    var container = $(".search--container");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if ((container.hasClass('opened') || container.hasClass('opened-mobile') || container.hasClass('opened-mobile2')) && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }
  });

  $(document).on('click', '.global-search', function () {
    //var url = window.location.hostname
    var search = document.getElementsByClassName('searchProduct')[0].value;

    var redirection = localePrefix + "/search?type=product&q=" + search;
    window.location.replace(redirection);
    $('.search--container').removeClass('opened');
  });
}

$(document).on('input', '.search--input', function () {
  if ($(this).attr('search') === 'barre') {
    SearchFunction('searchArticle-barre', 'article', 'result-search-barre');
  } else if ($(this).attr('search') === 'article') {
    SearchFunction('searchArticle', 'article', 'result-search');
  } else if ($(this).attr('search') === 'produit') {
    SearchFunction('searchProduct', 'product', 'result-search');
  }
});

var SearchFunction = function SearchFunction(classInput, typeSearch, classInputResult) {

  var htmlItem = function htmlItem(type, item, index) {
    if (type == "article") {
      return "<div class='one-product'><a class='flex fd--row jc--flex-start' href=" + localePrefix + item[index].url + "><img class='image-product' src=" + item[index].image + "><div class='content--container flex fd--column ai--flex-start'><p class='price--grid dark__color'>" + item[index].title + "</p></div></a></div>";
    } else {
      /*if (item[index].compare_at_price_max == 0.00) {
        var prix = item[index].price.replace('.', ',') +'€';
      } else {
        var prix = item[index].price.replace('.', ',') + "€<span class='line-through mx-[10px] mr-0'>" + item[index].compare_at_price_max.replace('.', ',') + "€</span>"
      }*/

      var getCurrencySymbol = function getCurrencySymbol() {
        var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        var s = String(str).trim();

        var closeIdx = s.indexOf("}}");
        // Cas 1: {{amount}}€  → il y a quelque chose après "}}"
        if (closeIdx !== -1) {
          var right = s.slice(closeIdx + 2).trim();
          if (right) return right; // ex: "€" ou "EUR"
        }

        // Cas 2: ${{amount}} → il y a quelque chose avant "{{"
        var openIdx = s.indexOf("{{");
        if (openIdx !== -1) {
          var left = s.slice(0, openIdx).trim();
          if (left) return left; // ex: "$" ou "USD"
        }

        return "";
      };

      var prix;
      if (window.general.currency.includes('$') || window.general.currency.includes('Afl')) {
        prix = window.translate.starting_at + (" " + getCurrencySymbol(window.general.currency)) + item[index].price_min.replace('.', ',');
      } else {
        prix = window.translate.starting_at + " " + item[index].price_min.replace('.', ',') + getCurrencySymbol(window.general.currency);
      }
      return " <div class='one-product'><a class='flex flex-col' href=" + localePrefix + item[index].url.replace('/en/', '/') + "><img class='w-full h-auto object-cover' src=" + item[index].image + "><div class='flex flex-col my-[10px] mb-0'><p class='body--text'>" + item[index].title + "</p><p class='price body--text'>" + prix + "</p></div></a></div>";
    }
  };

  var emptyItem = function emptyItem(type) {
    if (type == "article") {
      return "<div class='empty'>Aucun article ne correspond à votre recherche</div>";
    } else {
      return "<div class='empty px-[20px] py-[10px] text-center col-span-6 2xl:col-span-3 md:col-span-2 body--text text-grey'>Aucun produit ne correspond à votre recherche</div>";
    }
  };

  var q = document.getElementsByClassName(classInput)[0].value;
  var b = "&resources[type]=" + typeSearch;
  var c = '';
  if (q == "") {
    $(".result-search").html('');
    $(".result-search-barre").html('');
  }
  var type;
  if (typeSearch == 'article') {
    type = "article";
  } else {
    type = "product";
    c = '&fields=title,product_type,tag';
    if (q == "") {
      $(".popular_product").addClass('opened');
    } else {
      $(".popular_product").removeClass('opened');
    }
  }
  var first;
  if (window.general.langue !== "fr") {
    first = "/" + window.general.langue + "/search/suggest.json?q=";
  } else {
    first = "/search/suggest.json?q=";
  }
  $.ajax(first + q + b + c + '&resources[limit]=6', {
    type: 'GET',
    dataType: 'json',
    success: function success(response) {
      var itemsSuggestions = response.resources.results[typeSearch + "s"];
      if (itemsSuggestions.length > 0) {
        var result = "";
        for (var i = 0; i < itemsSuggestions.length; i++) {
          if (itemsSuggestions[i].id != 6623214993579 && itemsSuggestions[i].id != 6623216205995) {
            result += htmlItem(type, itemsSuggestions, i);
          }
        }

        if (type == "product") {
          result = result + ("<div class='global-search col-span-6 2xl:col-span-3 md:col-span-2 ml-[-20px] w-[calc(100%+40px)] sticky bottom-0 left-0 px-[20px] py-[10px] bg-primary cursor-pointer body--text text-secondary-light text-center'>" + window.translate.more_results + "</div>");
        }
        $("." + classInputResult).html(result);
      } else {
        var emptyProduct = emptyItem(type);
        $("." + classInputResult).html(emptyProduct);
      }
    }
  });
};
'use strict';

$('body').on('click', '.atc', function () {
  var attribute = $(this).attr("data-atc");
  if (event.ctrlKey || $(this).hasClass('atc_blank')) {
    var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
    newWindow.focus();
  } else {
    document.location.href = decodeURIComponent(window.atob(attribute));
  }
});
'use strict';

$(document).ready(function () {
    $(document).on('click', '.product-color', async function (e) {
        e.preventDefault();

        var productId = $(this).data('product-id');
        var productUrl = $(this).data('product-url');

        $('.product-color[data-product-id="' + productId + '"]').removeClass('active-color');
        $(this).addClass('active-color');

        var productCardEl = $(this).closest('.product__item--container');

        try {
            var response = await fetch(productUrl);
            if (!response.ok) {
                throw new Error('Response status: ' + response.status);
            }

            var documentString = await response.text();
            var parser = new DOMParser();
            var doc = parser.parseFromString(documentString, 'text/html');

            var newImage = doc.querySelector('.product--image');
            productCardEl.find('.product--image').replaceWith(newImage);

            var newHoverImage = doc.querySelector('.product--image-hover');
            productCardEl.find('.product--image-hover').replaceWith(newHoverImage);

            var newProductType = doc.querySelector('.product--type');
            productCardEl.find('.product--type').text(newProductType.textContent);

            var newProductLink = doc.querySelector('.product__item__link--container');
            productCardEl.find('.product__item__link--container').attr('href', newProductLink.getAttribute('href'));

            var newProductPrice = doc.querySelector('.product-card--price');
            productCardEl.find('.product-card--price').html(newProductPrice.innerHTML);
        } catch (error) {
            console.error('Erreur lors du fetch du produit:', error);
        }
    });
});
"use strict";

// Si le client veut la formule RGPD
// --> on supprime ce qui est non commente
// --> on decommente le reste

$(".button--cookie").click(function () {
  $("#cookie--banner").hide();
  $('#page__overlay--cookie').removeClass("opened");
});

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

if (getCookie('cookies-accepted') == 'yes') {} else {
  $("#cookie--banner").addClass("apparition--cookie");
  $('#page__overlay--cookie').addClass("opened");
}

$('#accept--all, #reject--all').on('click', function () {
  var CookieDate = new Date();
  CookieDate.setMonth(CookieDate.getMonth() + 12);
  document.cookie = "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
});
'use strict';

$('.button__with__loading').on('click', function () {
  $(this).children('.text--loading').hide();
  $(this).children('.button--loading').css('display', 'flex');
});

function deferSrcImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-src')) {
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('defer-src'));
    }
  }
}

window.onload = function () {
  document.dispatchEvent(new CustomEvent('update-reco-drawer'));

  setTimeout(function () {
    deferSrcImages("defer--product");
  }, 200);
};

$('.filter-projet').on('click', function () {
  var selectedFilter = $(this).attr('value');

  $('.filter-projet').removeClass('text-primary after:bg-primary').addClass('text-grey after:bg-[rgba(0,0,0,0)]');
  $(this).addClass('text-primary after:bg-primary').removeClass('text-grey after:bg-[rgba(0,0,0,0)]');

  if (selectedFilter == 'Tous les projets') {
    $('.one-projet-list').show();
  } else {
    $('.one-projet-list').each(function (i, item) {
      if ($(item).attr("tags__filter").includes(selectedFilter)) {
        $(item).show();
      } else {
        $(item).hide();
      }
    });
  }
});

$('.see-more-person').on('click', function () {
  var id = $(this).attr('section');
  $('.personne--container[section=' + id + ']').removeClass('hidden lg:hidden');
  $(this).hide();
});

$('.choice-langage').on('click', function () {
  if ($('.container-choice-langage').hasClass('hidden')) {
    $('.container-choice-langage').removeClass('hidden');
    $('.icon--arrow-bottom').addClass('opened');
  } else {
    $('.container-choice-langage').addClass('hidden');
    $('.icon--arrow-bottom').removeClass('opened');
  }
});

$('body').on('click', '.button-sur-mesure', function () {
  var link = $(this).attr('link');
  var largeur = $('#largeur').val();
  var longueur = $('#longueur').val();
  var color = $('#couleur').val();
  var mailto = link.replace('longueur', longueur).replace('largeur', largeur).replace('colorChoice', color);
  $('.button-sur-mesure').attr('href', mailto);
  $('.button-sur-mesure').click();
});

var pathname = window.location.pathname;
var langCode = pathname.split("/")[1];

var localePrefix = "";
if (/^[a-z]{2}(-[a-z]{2})?$/.test(langCode)) {
  localePrefix = '/' + langCode;
}

$('#checkout--button').attr('href', localePrefix + '/checkout');
$('.search-form').attr('action', localePrefix + '/search');

$('.article-click').on('click', function () {
  var background_url = "https:" + $(this).attr('background-img');
  $('#article--modal .image-article').attr('src', background_url);
});

$('#page__overlay, #article--modal .close').on('click', function () {
  if ($('#article--modal').hasClass('opened')) {
    $('#article--modal .image-article').attr('src', '');
  }
});

$('body').on('click', '.click-reco', function () {
  var productId = $(this).attr('product-id');
  var variantId = $(this).attr('variant-id');
  var variantAvailable = $(this).attr('variant-available');
  var price = $(this).attr('variant-price');

  $('.click-reco[product-id=' + productId + ']').removeClass('bg-secondary').addClass('bg-white');
  $('.click-reco[variant-id=' + variantId + ']').addClass('bg-secondary').removeClass('bg-white');

  $('.button-reco[product-id=' + productId + ']').attr('variant-id', variantId).attr('variant-available', variantAvailable);
  $('.price-reco[product-id=' + productId + ']').text(price);
  if (variantAvailable == false) {
    $('.button-reco[product-id=' + productId + ']').text('Rupture');
  } else {
    $('.button-reco[product-id=' + productId + ']').text('Ajouter');
  }
});

$('.seo-home-click').on('click', function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).text($(this).attr('see-more'));
    $(this).siblings('.seo-home-text--container').addClass('max-h-[100px] overflow-y-hidden');
  } else {
    $(this).addClass('active');
    $(this).text($(this).attr('see-less'));
    $(this).siblings('.seo-home-text--container').removeClass('max-h-[100px] overflow-y-hidden');
  }
});

/*document.querySelector('#country-select').addEventListener('change', function(e) {
  const selectedMarket = e.target.value;

  let newLang = '';
  switch (selectedMarket) {
    case 'US':
      newLang = 'en-us';
      break;
    case 'CH':
      newLang = 'fr-ch';
      break;
    case 'FR':
      newLang = '';
      break;
    case 'MC':
      newLang = '';
      break;
    case 'LU':
      newLang = 'fr-lu';
      break;
    case 'BE':
      newLang = 'fr-be';
      break;
    case 'PT':
      newLang = 'en-eu';
      break;
    case 'PL':
      newLang = 'en-eu';
      break;
    case 'NL':
      newLang = 'en-eu';
      break;
    case 'LV':
      newLang = 'en-eu';
      break;
    case 'IT':
      newLang = 'en-eu';
      break;
    case 'IE':
      newLang = 'en-eu';
      break;
    case 'ES':
      newLang = 'en-eu';
      break;
    case 'AT':
      newLang = 'en-eu';
      break;
    case 'DE':
      newLang = 'en-eu';
      break;
  }

  const path = window.location.pathname.split('/');
  if (path[1] && ['en', 'en-us', 'fr-ch', 'fr-lu', 'fr-be', 'en-eu', 'fr-eu', 'en-be', 'en-lu', 'en-ch', 'fr-us'].includes(path[1])) {
    path[1] = newLang;
  }

  const newUrl = window.location.origin + path.join('/') + window.location.search;
  window.location.href = newUrl;
});*/

$(document).ready(function () {
  var marketSelector = document.querySelector('#country-select');
  var languageSelect = document.querySelector('#language-select');

  if (!marketSelector || !languageSelect) return;

  var marketToLanguage = {
    'be': 'fr',
    'ca': 'fr',
    'ch': 'fr',
    'fr': 'fr',
    'lu': 'fr',
    'mc': 'fr'
  };

  marketSelector.addEventListener('change', function (e) {
    var selectedMarket = e.target.value.toLowerCase();
    var desiredLang = marketToLanguage[selectedMarket] || 'en';
    console.log('desiredLang:', desiredLang);

    if (!desiredLang) return;

    // Cherche et sélectionne la bonne option
    var options = languageSelect.options;
    for (var i = 0; i < options.length; i++) {
      var option = options[i];

      if (option.value.toLowerCase() === desiredLang || option.textContent.trim().toLowerCase().startsWith(desiredLang)) {
        languageSelect.selectedIndex = i;

        var event = new Event('change', { bubbles: true });
        languageSelect.dispatchEvent(event);
      }
    }
  });
});

if (window.location.href.indexOf("/contact") > -1) {
  $('#hubspot .hs-submit .hs-button').on('click', function () {
    setTimeout(function () {
      $('html, body').animate({ scrollTop: 0 }, 500);
    }, 500);
  });
}
'use strict';

$('#go-top').on('click', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

if ($(document).scrollTop() > 20) {
  $('#go-top').show();
} else {
  $('#go-top').hide();
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $('#go-top').show();
  } else {
    $('#go-top').hide();
  }
});
"use strict";

var displayPrice = function displayPrice(price) {
  return price / 100;
};
'use strict';

$('.newsletter-form').submit(function (e) {
  e.preventDefault();
  if ($('.checkbox--newsletter').hasClass('checked') && (window.footer.has_not_perso_pro || $('.type-client').hasClass('checked'))) {
    $('.checkbox--email').hide();

    var index = $(this).attr('form-index');
    var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
    var type = $('.type-client.checked[form-index="' + index + '"]').attr('value');
    var fields = "$source,$email,$consent,$type";

    var formData = {
      "email": email,
      "g": $('.list--newsletter[form-index="' + index + '"]').val(), // liste klaviyo
      "$consent": "email",
      "$source": $('.newsletter-form[form-index="' + index + '"]').attr('source'),
      "$fields": fields,
      "$type": type
    };

    $.ajax({
      type: "POST",
      url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      data: formData,
      dataType: 'json',
      success: function success(response) {
        if (response.errors && response.errors.length > 0) {
          $('.newsletter-form .error--email').show();
          _learnq.push(['identify', {
            '$email': email
          }]);
        } else {
          $('.newsletter-form .success--email').show();
        }
      },
      error: function error(_error) {
        $('.newsletter-form .error--email').show();
      }
    });
  } else {
    if ($('.checkbox--newsletter').hasClass('checked')) {
      $('.type--email').show();
      setTimeout(function () {
        $('.type--email').hide();
      }, 2000);
    } else {
      $('.checkbox--email').show();
      setTimeout(function () {
        $('.checkbox--email').hide();
      }, 2000);
    }
  }
});

$('.checkbox--newsletter').on('click', function () {
  if ($(this).hasClass('checked')) {
    $(this).removeClass('checked bg-grey').addClass('bg-secondary-light');
  } else {
    $(this).addClass('checked bg-grey').removeClass('bg-secondary-light');
  }
});

$('.type-client').on('click', function () {
  var value = $(this).attr('value');
  $('.type-client.checked .checkbox').removeClass('bg-grey');
  $('.type-client').removeClass('checked');
  $('.type-client[value=' + value + ']').addClass('checked');
  $('.type-client[value=' + value + ']').find('.checkbox').addClass('bg-grey');
});
'use strict';

$('.faq-question--container').on('click', function () {
  var $question = $(this).children('.faq__question');
  $('.plus__icon').removeClass('opened');
  $question.children('.plus__icon').toggleClass('opened');
  if ($question.next().attr('aria-hidden') == 'false') {
    $question.next().slideToggle(200).attr('aria-hidden', 'true');
    $('.plus__icon').removeClass('opened');
  } else {
    $('.faq-question--container').find('.faq__answer[aria-hidden="false"]').not($question).slideToggle(200).attr('aria-hidden', 'true');
    $question.next().slideToggle(200).attr('aria-hidden', 'false');
  }
});

$('.faq-link').on('click', function () {
  var block = $(this).attr('link');
  $('html, body').animate({
    scrollTop: $(block).offset().top - 150
  }, 500);
});

$('.to-hubspot').on('click', function () {
  var block = '#hubspot';
  $('html, body').animate({
    scrollTop: $(block).offset().top - 150
  }, 500);
});
'use strict';

$(document).ready(function () {
    var KLAVIYO_URL = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';

    // Initialisation de l'alerte de stock
    var alertForm = $('.js-stock-alert-form');

    // Affiche le formulaire d'alerte de stock
    $('body').on('click', '.js-stock-alert-btn', function () {
        $('.js-alert-stock-container').removeClass('hidden');
        $(this).addClass('hidden');
    });

    $('body').on('click', '.js-form-alert-submit', function (e) {
        sendKlaviyoForm(e);
    });

    // Envoi des données à Klaviyo
    async function sendKlaviyoForm(e) {
        e.preventDefault();

        var $alertFormBtn = $('.js-form-alert-submit');

        var email = $('.js-form-alert-input').val();

        if (!isValidEmail(email)) {
            $('.js-email-error').removeClass('hidden');
            return;
        }

        var variantId = $('.js-alert-stock-container').data('variant-id');
        var klaviyoApiKey = $('.js-alert-stock-container').data('klaviyo-key');

        if (!variantId || !email || !klaviyoApiKey) {
            return;
        }

        var klaviyoData = {
            a: klaviyoApiKey,
            platform: 'shopify',
            variant: variantId,
            email: email
        };

        var headers = {
            accept: 'application/json, text/plain, */*',
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
        };

        var body = new URLSearchParams(klaviyoData).toString();

        // Appel de l'API avec fetch
        fetch(KLAVIYO_URL, {
            headers: headers,
            body: body,
            method: 'POST'
        }).then(function (response) {
            // Si la réponse est OK ou si c'est une erreur 410
            if (response.ok || response.status === 410) {
                // Appliquez la logique pour indiquer le succès
                $alertFormBtn.addClass('button--checked');
                $('.js-email-error').addClass('hidden');
                alertForm.addClass('hidden');
                $('.js-form-alert-sent').removeClass('hidden');
                $alertFormBtn.off('click');
                document.dispatchEvent(new Event('alert-stock'));
            } else {
                // Gérez les autres erreurs ici si nécessaire
                console.error('Failed to send form: HTTP error', response.status);
            }
        }).catch(function (error) {
            // Erreurs réseau, telles qu'une déconnexion ou un problème avec le serveur
            console.error('Network error:', error);

            if (error.message === "Failed to fetch") {
                // Appliquez la logique même en cas d'erreur réseau
                $alertFormBtn.addClass('button--checked');
                $('.js-email-error').addClass('hidden');
                alertForm.addClass('hidden');
                $('.js-form-alert-sent').removeClass('hidden');
                $alertFormBtn.off('click');
                document.dispatchEvent(new Event('alert-stock'));
            }
        });
    }

    // Validation de l'adresse email
    function isValidEmail(value) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).toLowerCase());
    }
});
"use strict";

if (window.general.photoSwipe == true) {
    var containers = {};
    var galleries = {};

    $(".product__images--container").each(function () {
        var productHandle = $(this).attr("product-handle");
        containers[productHandle] = [];
        galleries[productHandle] = "";

        $(this).find("#slider--product, #slider--product2").find(".carousel-cell").each(function () {
            var $link = $(this).find(".product__image"),
                item = {
                src: $link.attr("src"),
                w: $link.attr("width"),
                h: $link.attr("height")
            };
            containers[productHandle].push(item);
        });

        // Define click event on gallery item
        $(this).on("click", "#slider--product .carousel-cell, #slider--product2 .carousel-cell", function (event) {
            // Prevent location change
            event.preventDefault();

            // Define object and gallery options
            var $pswp = $("#product-swipe-" + productHandle + " .pswp")[0],
                options = {
                index: $(this).index()
            };

            // Initialize PhotoSwipe
            galleries[productHandle] = new PhotoSwipe($pswp, PhotoSwipeUI_Default, containers[productHandle], options);
            galleries[productHandle].init();

            if (window.matchMedia("(max-width: 1000px)").matches) {
                $(this).parents(".product__images--container").find("#slider--product, #slider--product2").find(".carousel-cell").each(function () {
                    var id = $(this).attr("id");
                    if (id !== undefined) {
                        $(this).find(".product__image").clone().appendTo("#product-swipe-" + productHandle + " .pswp__thumbnail");
                    }
                });
            } else {
                $(this).parents(".product__images--container").find("#slider--product img, #slider--product2 img").clone().appendTo("#product-swipe-" + productHandle + " .pswp__thumbnail");
            }

            $("#product-swipe-" + productHandle + " .button-pswp--container, #product-swipe-" + productHandle + " .pswp__thumbnail").addClass("opened");

            $("#product-swipe-" + productHandle + " .pswp__thumbnail img").eq(galleries[productHandle].getCurrentIndex()).addClass("active");

            galleries[productHandle].listen("close", function () {
                $("#product-swipe-" + productHandle + " .pswp__thumbnail img").remove();
                $("#product-swipe-" + productHandle + " .button-pswp--container, #product-swipe-" + productHandle + " .pswp__thumbnail").removeClass("opened");
            });
        });

        // Handle pswp
        $("body").on("click", "#product-swipe-" + productHandle + " .pswp__thumbnail img", function (e) {
            $("#product-swipe-" + productHandle + " .pswp__thumbnail img").removeClass("active");
            $(this).addClass("active");

            var number = $("#product-swipe-" + productHandle + " .pswp__thumbnail img").index($(this));
            galleries[productHandle].goTo(number);

            $("#product-swipe-" + productHandle + " .button-zoom-pswp").children(".see-more").removeClass("opened");
        });

        $("body").on("click", "#product-swipe-" + productHandle + " .button-close-pswp", function () {
            galleries[productHandle].close();
        });

        $("body").on("click", "#product-swipe-" + productHandle + " .button-zoom-pswp", function () {
            galleries[productHandle].toggleDesktopZoom();
            if ($("#product-swipe-" + productHandle + " .pswp").hasClass("pswp--zoomed-in")) {
                $("#product-swipe-" + productHandle + " .button-zoom-pswp").children(".see-more").addClass("opened");
            } else {
                $("#product-swipe-" + productHandle + " .button-zoom-pswp").children(".see-more").removeClass("opened");
            }
        });

        $("body").on("click", "#product-swipe-" + productHandle + " .pswp__img", function () {
            if ($("#product-swipe-" + productHandle + " .pswp").hasClass("pswp--zoomed-in")) {
                $("#product-swipe-" + productHandle + " .button-zoom-pswp").children(".see-more").addClass("opened");
            } else {
                $("#product-swipe-" + productHandle + " .button-zoom-pswp").children(".see-more").removeClass("opened");
            }
        });
    });
}
"use strict";

// Handle product configurator accordion
//
// @param {string} data-configurator-gallery-selector
// @param {string} data-configurator-submit-selector
// @param {string} data-product-gallery-selector
// @param {string} data-product-submit-selector
// @param {string} data-product-accordion-selector
// @param {string} data-configurator-price
// @param {string} data-configurator-product-id
// @param {string} data-customer-id
//
// @example
// <w3-product-configurator
//    data-configurator-gallery-selector="..."
//    data-configurator-submit-selector="..."
//    data-product-gallery-selector="..."
//    data-product-submit-selector="..."
//    data-product-accordion-selector="..."
//    data-configurator-price="..."
//    data-configurator-product-id="..."
//    data-customer-id="..."
// >
//     <details></details>
// </w3-product-configurator>

$(document).ready(function () {
    var ProductConfiguratorEl = document.querySelector("w3-product-configurator");
    if (!ProductConfiguratorEl) return;

    // Attributes
    var configuratorGallerySelector = ProductConfiguratorEl.dataset.configuratorGallerySelector;
    var configuratorSubmitSelector = ProductConfiguratorEl.dataset.configuratorSubmitSelector;
    var productGallerySelector = ProductConfiguratorEl.dataset.productGallerySelector;
    var productSubmitSelector = ProductConfiguratorEl.dataset.productSubmitSelector;
    var productAccordionSelector = ProductConfiguratorEl.dataset.productAccordionSelector;
    var configuratorPrice = Number.parseFloat(ProductConfiguratorEl.dataset.configuratorPrice);
    var configuratorProductId = ProductConfiguratorEl.dataset.configuratorProductId;
    var customerId = ProductConfiguratorEl.dataset.customerId;

    // Attributes validation
    if (!configuratorGallerySelector) return;
    if (!configuratorSubmitSelector) return;
    if (!productGallerySelector) return;
    if (!productSubmitSelector) return;
    if (!productAccordionSelector) return;
    if (!configuratorPrice) return;
    if (!configuratorProductId) return;

    // Elements
    var configuratorGalleryEl = document.querySelector(configuratorGallerySelector);
    var configuratorSubmitEl = document.querySelector(configuratorSubmitSelector);
    var productGalleryEl = document.querySelector(productGallerySelector);
    var productSubmitEl = document.querySelector(productSubmitSelector);
    var productAccordionEl = document.querySelector(productAccordionSelector);

    var configuratorDetailsEl = ProductConfiguratorEl.querySelector("details");
    var configuratorDiameterInputEl = ProductConfiguratorEl.querySelector("input[name='configurator-diameter']");
    var configuratorLengthInputEl = ProductConfiguratorEl.querySelector("input[name='configurator-length']");
    var configuratorWidthInputEl = ProductConfiguratorEl.querySelector("input[name='configurator-width']");
    var configuratorDiameterErrorEl = ProductConfiguratorEl.querySelector(".configurator-diameter-error");
    var configuratorLengthErrorEl = ProductConfiguratorEl.querySelector(".configurator-length-error");
    var configuratorWidthErrorEl = ProductConfiguratorEl.querySelector(".configurator-width-error");
    var configuratorAreaEl = ProductConfiguratorEl.querySelector(".product-configurator-area");
    var configuratorTotalEl = ProductConfiguratorEl.querySelector(".product-configurator-total");
    var configuratorDialogEl = ProductConfiguratorEl.querySelector("#product-configurator-dialog");

    // Elements validation
    if (!configuratorGalleryEl) return;
    if (!configuratorSubmitEl) return;
    if (!productGalleryEl) return;
    if (!productSubmitEl) return;
    if (!productAccordionEl) return;

    if (!configuratorDetailsEl) return;
    if (!configuratorAreaEl) return;
    if (!configuratorTotalEl) return;
    if (!configuratorDialogEl) return;

    // Handle open and close of configurator accordion
    configuratorDetailsEl.addEventListener("toggle", function (e) {
        if (e.target.open) {
            // Hide default product gallery and submit button
            productGalleryEl.style.position = "absolute";
            productGalleryEl.style.pointerEvents = "none";
            productGalleryEl.style.opacity = "0";
            productSubmitEl.style.display = "none";

            // Apply transparent background color on product accordion
            productAccordionEl.style.backgroundColor = "transparent";

            // Show configurator gallery and submit button
            configuratorGalleryEl.style.position = "";
            configuratorGalleryEl.style.pointerEvents = "";
            configuratorGalleryEl.style.opacity = "";
            configuratorSubmitEl.style.display = "";
        } else {
            // Hide configurator gallery and submit button
            configuratorGalleryEl.style.position = "absolute";
            configuratorGalleryEl.style.pointerEvents = "none";
            configuratorGalleryEl.style.opacity = "0";
            configuratorSubmitEl.style.display = "none";

            // Remove transparent background color on product accordion
            productAccordionEl.style.backgroundColor = "";

            // Show default product gallery and submit button
            productGalleryEl.style.position = "";
            productGalleryEl.style.pointerEvents = "";
            productGalleryEl.style.opacity = "";
            productSubmitEl.style.display = "";
        }
    });

    // Handle product size accordion click
    productAccordionEl.addEventListener("click", function (e) {
        configuratorDetailsEl.open = false;
    });

    // Handle configurator inputs
    var handleConfiguratorTotal = function handleConfiguratorTotal(length, lengthMin, lengthMax, lengthErrorEl, width, widthMin, widthMax, widthErrorEl) {
        var area = Number.parseFloat(length / 100 * (width / 100)).toFixed(2).replace(".00", "");
        var total = Number.parseFloat((length <= widthMax && length > width ? width : length) / 100 * configuratorPrice).toFixed(2).replace(".00", "");

        configuratorAreaEl.textContent = "" + (area.toString() === "NaN" ? "0" : area) + configuratorAreaEl.dataset.unit;
        configuratorTotalEl.textContent = "" + (total.toString() === "NaN" ? "0" : total) + configuratorTotalEl.dataset.unit;

        if (length < lengthMin || length > lengthMax) {
            lengthErrorEl.style.display = "";
            configuratorSubmitEl.disabled = true;
        } else {
            lengthErrorEl.style.display = "none";
        }

        if (width < widthMin || width > widthMax) {
            widthErrorEl.style.display = "";
            configuratorSubmitEl.disabled = true;
        } else {
            widthErrorEl.style.display = "none";
        }

        if (length >= lengthMin && length <= lengthMax && width >= widthMin && width <= widthMax) {
            configuratorSubmitEl.disabled = false;
        }
    };

    var handleConfiguratorSubmit = async function handleConfiguratorSubmit(length, width, diameter) {
        if (customerId) {
            configuratorSubmitEl.disabled = true;

            var url = "https://europe-west9-site-toulemondeb-1550046720387.cloudfunctions.net/gcr-tlmb-draft-orders";
            var data = diameter > 0 ? {
                customerId: "gid://shopify/Customer/" + customerId,
                variantId: "gid://shopify/ProductVariant/" + configuratorProductId,
                quantity: 1,
                diameter: Number.parseInt(diameter)
            } : {
                customerId: "gid://shopify/Customer/" + customerId,
                variantId: "gid://shopify/ProductVariant/" + configuratorProductId,
                quantity: 1,
                length: Number.parseInt(length),
                width: Number.parseInt(width)
            };

            try {
                var response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            } catch (error) {
                console.error("[⚙️ Configurator] Error:", error);
            } finally {
                configuratorDialogEl.showModal();
                configuratorSubmitEl.disabled = false;
            }
        }
    };

    if (configuratorLengthInputEl && configuratorWidthInputEl && configuratorLengthErrorEl && configuratorWidthErrorEl) {
        configuratorLengthInputEl.addEventListener("input", function () {
            return handleConfiguratorTotal(Math.round(Number.parseFloat(configuratorLengthInputEl.value)), Number.parseInt(configuratorLengthInputEl.getAttribute("min")), Number.parseInt(configuratorLengthInputEl.getAttribute("max")), configuratorLengthErrorEl, Math.round(Number.parseFloat(configuratorWidthInputEl.value)), Number.parseInt(configuratorWidthInputEl.getAttribute("min")), Number.parseInt(configuratorWidthInputEl.getAttribute("max")), configuratorWidthErrorEl);
        });
        configuratorWidthInputEl.addEventListener("input", function () {
            return handleConfiguratorTotal(Math.round(Number.parseFloat(configuratorLengthInputEl.value)), Number.parseInt(configuratorLengthInputEl.getAttribute("min")), Number.parseInt(configuratorLengthInputEl.getAttribute("max")), configuratorLengthErrorEl, Math.round(Number.parseFloat(configuratorWidthInputEl.value)), Number.parseInt(configuratorWidthInputEl.getAttribute("min")), Number.parseInt(configuratorWidthInputEl.getAttribute("max")), configuratorWidthErrorEl);
        });

        configuratorSubmitEl.addEventListener("click", function () {
            return handleConfiguratorSubmit(Math.round(Number.parseFloat(configuratorLengthInputEl.value)), Math.round(Number.parseFloat(configuratorWidthInputEl.value)), 0);
        });
    }

    if (configuratorDiameterInputEl && configuratorDiameterErrorEl) {
        configuratorDiameterInputEl.addEventListener("input", function () {
            return handleConfiguratorTotal(Math.round(Number.parseFloat(configuratorDiameterInputEl.value)), Number.parseInt(configuratorDiameterInputEl.getAttribute("min")), Number.parseInt(configuratorDiameterInputEl.getAttribute("max")), configuratorDiameterErrorEl, Math.round(Number.parseFloat(configuratorDiameterInputEl.value)), Number.parseInt(configuratorDiameterInputEl.getAttribute("min")), Number.parseInt(configuratorDiameterInputEl.getAttribute("max")), configuratorDiameterErrorEl);
        });

        configuratorSubmitEl.addEventListener("click", function () {
            return handleConfiguratorSubmit(0, 0, Math.round(Number.parseFloat(configuratorDiameterInputEl.value)));
        });
    }
});
"use strict";

$(".product__images--container").each(function () {
    console.log("prevArrowGallery:", prevArrowGallery);
    console.log("nextArrowGallery:", nextArrowGallery);

    $(this).find("#slider--product").slick({
        dots: false,
        infinite: false,
        arrows: false,
        waitForAnimate: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        asNavFor: $(this).find("#slider__nav--product"),
        responsive: [{
            breakpoint: 950,
            settings: {
                arrows: true,
                prevArrow: prevArrowGallery,
                nextArrow: nextArrowGallery
            }
        }]
    });

    $(this).find("#slider--product2").slick({
        dots: false,
        infinite: false,
        arrows: false,
        waitForAnimate: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        responsive: [{
            breakpoint: 950,
            settings: {
                arrows: true,
                prevArrow: prevArrowGallery,
                nextArrow: nextArrowGallery
            }
        }]
    });

    $(this).find("#slider__nav--product").slick({
        dots: false,
        infinite: false,
        arrows: true,
        prevArrow: prevArrowGallery,
        nextArrow: nextArrowGallery,
        waitForAnimate: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        vertical: true,
        asNavFor: $(this).find("#slider--product")
    });

    $(this).find("#slider__nav--product2").slick({
        dots: false,
        infinite: false,
        arrows: true,
        prevArrow: prevArrowGallery,
        nextArrow: nextArrowGallery,
        waitForAnimate: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        vertical: true
    });

    $(this).find("#slider__nav--product2 .thumb--image").on("click", function () {
        var index = $(this).attr("thumb-index");
        var slider = $(this).parents(".product__images--container").find("#slider--product2");
        slider.slick("slickGoTo", index);
    });

    $(this).find("#slider__nav--product .thumb--image").on("click", function () {
        var index = $(this).attr("thumb-index");
        var slider = $(this).parents(".product__images--container").find("#slider--product");
        slider.slick("slickGoTo", index);
    });
});
'use strict';

$(document).ready(function () {
    if (window.location.href.indexOf("/products/") > -1) {
        var ProductRecentlyViewed = function ProductRecentlyViewed() {
            this.productViewed = $('#product__top--container');
            this.productViewedHandle = this.productViewed.data('productHandle');
            this.localStorageProducts = JSON.parse(localStorage.getItem('product-recently-viewed'));
            this.productsViewed = [];
            this.fillLocalStorage();
        };

        ProductRecentlyViewed.prototype.fillLocalStorage = function () {
            // if first init and no local storage
            if (this.localStorageProducts == null) {
                this.localStorageProducts = [];
            }

            var productsArray = this.localStorageProducts;

            if (productsArray.includes(this.productViewedHandle)) {
                return;
            }

            // remove first element if more than 6 items
            if (productsArray && productsArray.length > 6) {
                productsArray.shift();
            }

            // push current product
            productsArray.push(this.productViewedHandle);

            // convert array as json
            var productsArrayData = JSON.stringify(productsArray);
            // store into local storage
            localStorage.setItem('product-recently-viewed', productsArrayData);
        };

        new ProductRecentlyViewed();
    }
});
'use strict';

$(document).ready(function () {
    var $productRecentlyViewedEl = $('.product-recently-viewed');
    var shopifyLocale = Shopify.locale == 'fr' ? '' : '/' + Shopify.locale;

    function getProductsFromLocalStorage() {

        var localStorageProducts = JSON.parse(localStorage.getItem('product-recently-viewed'));

        if (localStorageProducts && localStorageProducts.length > 0) {
            localStorageProducts.reverse();

            var productsLoaded = 0;

            for (var i = 0; i < localStorageProducts.length; i++) {
                if (localStorageProducts[i] === '') {
                    return;
                }

                $.ajax({
                    url: window.Shopify.routes.root + 'products/' + localStorageProducts[i] + '?view=product-grid-item-home',
                    method: 'GET',
                    success: function success(response) {
                        var productCardEl = $.parseHTML($.trim(response))[0];
                        console.log('[ProductRecentlyViewed] productCardEl:', productCardEl);

                        if (productCardEl) {
                            $productRecentlyViewedEl.append(productCardEl);
                            productsLoaded++;
                        }

                        var cleanLength = localStorageProducts.filter(function (p) {
                            return p && Object.keys(p).length > 0;
                        }).length;
                        if (productsLoaded === cleanLength) {
                            initializeSlider(productsLoaded);
                        }
                    },
                    error: function error(response) {
                        if (!response.ok || response.redirected) {
                            var error = new Error(response.status);

                            // if product doesn't exist, throw error
                            // and remove product from local storage
                            localStorageProducts = localStorageProducts.filter(function (product) {
                                return product !== localStorageProducts[i];
                            });

                            // convert array as json
                            var productsArrayData = JSON.stringify(localStorageProducts);
                            // store into local storage
                            localStorage.setItem('product-recently-viewed', productsArrayData);

                            throw error;
                        }
                    }
                });
            }
        } else {
            $('.button-recently').hide();
        }
    }

    function initializeSlider(productsCount) {
        setTimeout(function () {
            if (window.matchMedia("(min-width: 768px)").matches) {
                /*$('.slider-produit-recently').slick({
                    dots: false,
                    infinite: true,
                    arrows: true,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: productsCount > 5,
                    responsive: [
                        {
                            breakpoint: 1150,
                            settings: {
                                slidesToShow: 3
                            }
                        }
                    ]
                });*/
            }
        }, 500);
        setTimeout(function () {
            $('#recently-view').addClass('hidden');
            //$('#also-like').addClass('hidden')
        }, 800);
    }

    // prevent from initializing twice
    if ($('product-recently-viewed').length === 0) {
        getProductsFromLocalStorage();
    }
});
'use strict';

function calculateEta() {
  var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var daysToAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  // Calcul de Pâques
  function getEasterDate(year) {
    var f = Math.floor,
        G = year % 19,
        C = f(year / 100),
        H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
        I = H - f(H / 28) * (1 - f(H / 28) * f(29 / (H + 1)) * f((21 - G) / 11)),
        J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
        L = I - J,
        month = 3 + f((L + 40) / 44),
        day = L + 28 - 31 * f(month / 4);
    return new Date(year, month - 1, day);
  }

  function getFrenchHolidays(year) {
    var easter = getEasterDate(year);
    return [new Date(year, 0, 1), // Nouvel An
    new Date(year, 4, 1), // Fête du Travail
    new Date(year, 4, 8), // Victoire 1945
    new Date(year, 6, 14), // Fête nationale
    new Date(year, 7, 15), // Assomption
    new Date(year, 10, 1), // Toussaint
    new Date(year, 10, 11), // Armistice
    new Date(year, 11, 25), // Noël
    new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + 1), // Lundi de Pâques
    new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + 39), // Ascension
    new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + 50) // Lundi Pentecôte
    ];
  }

  function isHoliday(date, holidays) {
    return holidays.some(function (h) {
      return h.getFullYear() === date.getFullYear() && h.getMonth() === date.getMonth() && h.getDate() === date.getDate();
    });
  }

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var addedDays = 0;
    var holidays = getFrenchHolidays(result.getFullYear());

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6 && !isHoliday(result, holidays)) {
        addedDays++;
      }

      // Switch year
      if (result.getFullYear() !== holidays[0].getFullYear()) {
        holidays = getFrenchHolidays(result.getFullYear());
      }
    }

    return result;
  }

  function formatDate(date) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return day + '/' + month + '/' + year;
  }

  return formatDate(addBusinessDays(startDate, daysToAdd));
}

var productDetails = {};
if ($('[product-details]').html()) {
  productDetails = JSON.parse($('[product-details]').html());
}

document.addEventListener('select-changed:product__option', function (event) {
  onOptionChanged();
}, false);

function updateProductButton(variant, productId) {
  if (!$('.js-alert-stock-container').hasClass('hidden')) {
    $('.js-alert-stock-container').addClass('hidden');
    $('.js-bouton-add-to-cart').removeClass('hidden');
  }
  if ($('.js-stock-alert-form').hasClass('hidden')) {
    $('.js-stock-alert-form').removeClass('hidden');
    $('.js-form-alert-sent').addClass('hidden');
  }
  if (variant.available == 0) {
    //$(`.add__to__cart[product-id="${productId}"]`).html(`${window.translate.out_of_stock}`).attr('id', 'BIS_trigger').attr('variant-available', false).attr('data-variant-id', variant.id);
    $('.add__to__cart[product-id="' + productId + '"]').html('' + window.translate.out_of_stock).attr('variant-available', false).addClass('js-stock-alert-btn');
    $('.shipping-text').addClass('hidden');
  } else {
    //$(`.add__to__cart[product-id="${productId}"]`).html(`${window.translate.add_to_cart}`).attr('id', '').attr('variant-available', true);
    $('.add__to__cart[product-id="' + productId + '"]').html('' + window.translate.add_to_cart).attr('variant-available', true).removeClass('js-stock-alert-btn');
    $('.shipping-text').removeClass('hidden');
    if (variant.delai_stock != "") {
      $('.shipping-text-text').text(variant.delai_stock);
    } else {
      $('.shipping-text-text').text('' + window.translate.stock_shipping);
    }
  }
}

function onOptionChanged() {

  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length > 1) {
    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {
        $('.price-js').text(variant.price);

        if (variant.compareAtPrice != "") {
          $('.compare-price-js').text(variant.compareAtPrice).addClass('mx-[10px] ml-0').show();
        } else {
          $('.compare-price-js').removeClass('mx-[10px] ml-0').hide();
        }

        var pourcentage = Math.round((1 - parseInt(variant.priceBrut) / parseInt(variant.compareAtPriceBrut)) * 100);
        if (pourcentage) {
          $('.sales__tag--container').show().text("-" + pourcentage + "%");
        } else {
          $('.sales__tag--container').hide().text('');
        }

        var $addBtn = $('.add__to__cart[product-id="' + productDetails.productId + '"]');
        $addBtn.attr('variant-id', variant.id);

        var etaValue = variant.delai_stock_small && variant.delai_stock_small.trim() !== '' ? variant.delai_stock_small : calculateEta();
        $addBtn.attr('eta', etaValue);

        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        $('.stock-alert[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        window.history.replaceState({ path: url }, '', url);
        var featuredImage = variant.imageId;

        // Change image on variant change
        var imageNumber = parseInt($('#slider--product .product__image[image-id="' + featuredImage + '"]').attr("slide-number")) - 1;
        if (!isNaN(imageNumber)) {
          $('#slider--product').slick('slickGoTo', imageNumber);
        }

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
}

$('.quantity__change--selector-product').on('click', function () {
  var type = $(this).attr('type');
  var currentQty = parseInt($('.product__qty--container .quantity__current').val());

  if (type == 'minus') {
    if (currentQty != 0) {
      $('.product__qty--container .quantity__current').val(currentQty - 1);
    }
  } else {
    $('.product__qty--container .quantity__current').val(currentQty + 1);
  }
});

$('.bulle__custom--value').on('click', function () {
  var value = $(this).text();
  var option = $(this).attr('for');

  $('.select__custom--selected-value[for="' + option + '"]').text(value);
  $('.bulle__custom--value[for="' + option + '"]').removeClass('border-secondary');
  $(this).addClass('border-secondary');

  document.dispatchEvent(new CustomEvent('select-changed:product__option'));
});

$('.title-infos').on('click', function () {
  var id = $(this).attr('link');
  $('.title-infos').addClass('text-grey').removeClass('text-primary active');
  $(this).addClass('text-primary active').removeClass('text-grey');
  $('.product-infos--container').addClass('hidden');
  $('#' + id).removeClass('hidden');
});

$('.title-infos-2').on('click', function () {
  var id = $(this).attr('link');
  $('.title-infos-2').addClass('text-grey').removeClass('text-primary active');
  $(this).addClass('text-primary active').removeClass('text-grey');
  $('.recently-view--container').addClass('hidden');
  $('#' + id).removeClass('hidden');
  if (id == "recently-view") {
    var productsCount = $('.slider-produit-recently').children('div').length;

    if (!$('.slider-produit-recently').hasClass('slick-initialized') && window.matchMedia("(min-width: 768px)").matches) {
      setTimeout(function () {
        $('.slider-produit-recently').slick({
          dots: false,
          infinite: true,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          slidesToShow: 5,
          slidesToScroll: 1,
          centerMode: productsCount > 5,
          responsive: [{
            breakpoint: 1150,
            settings: {
              slidesToShow: 3
            }
          }]
        });
        $('.slider-produit-recently').removeClass('opacity-0');
      }, 200);
    }
  }
});

$('.see-more-pruduct').on('click', function () {
  $('html, body').animate({
    scrollTop: $('.title-infos--container').offset().top - 220
  }, 500);
});

if (window.location.href.indexOf("/products/") > -1) {
  var form = document.getElementById('contact_form');
  if (form) {
    form.addEventListener('submit', function (event) {
      event.stopImmediatePropagation();

      var email = document.getElementById('email-sur-mesure').value;
      var newsletter = document.getElementById('newsletter').checked;

      if (newsletter == true) {
        var formData = {
          "email": email,
          "g": 'UcqtDE'
        };

        $.ajax({
          type: "POST",
          url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
          data: formData,
          dataType: 'json',
          success: function success(response) {
            if (response.errors && response.errors.length > 0) {
              $('.newsletter-form .error--email').show();
              _learnq.push(['identify', {
                '$email': email
              }]);
            } else {
              $('.newsletter-form .success--email').show();
            }
            form.submit();
          },
          error: function error(_error) {
            $('.newsletter-form .error--email').show();
          }
        });
      } else {
        $(this).off('submit').submit();
      }
    });
  }

  // Add Eta on CTA
  $(document).ready(function () {
    var $btn = $('.js-bouton-add-to-cart');
    if (!$btn.length) return;

    var existingEta = $btn.attr('eta');
    if (existingEta && existingEta.trim() !== '') return;

    // Utilisation de la fonction réutilisable
    var formattedDate = calculateEta(); // par défaut J+2 jours ouvrés
    $btn.attr('eta', formattedDate);
  });
}

$(document).ready(function () {
  var $select = $('.select__hidden');

  if ($select.length) {
    var initialIndex = $select.prop('selectedIndex');
    if (initialIndex != 0) {
      updateAllVariantLinks();
    }

    $select.on('change', function () {
      updateAllVariantLinks();
    });
  }

  function updateAllVariantLinks() {
    var index = $select.prop('selectedIndex');

    $('.product-color-variant').each(function () {
      var $el = $(this);

      var baseLink = $el.data('link');
      var variantId = $el.data('variant-' + index);

      if (!baseLink || !variantId) return;

      var separator = baseLink.includes('?') ? '&' : '?';
      var newLink = baseLink + separator + 'variant=' + variantId;

      $el.attr('href', newLink);
    });
  }
});
});